import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const { protocol, host, port } = window.location;

export const workflowApi = createApi({
    reducerPath: 'workflowReducer',
    baseQuery: fetchBaseQuery({
        baseUrl: `${protocol}//${host}${port.length > 0 ? '' : `:${port}`}/api/workflow`,
        prepareHeaders: headers => {
            headers.set('Accept', 'application/json');
            return headers;
        },
    }),
    tagTypes: ['Workflows'],
    endpoints: () => ({}),
});
